import { render, staticRenderFns } from "./open-so-detail-report.vue?vue&type=template&id=f5507dc0&scoped=true&"
import script from "./js/open-so-detail-report.js?vue&type=script&lang=js&"
export * from "./js/open-so-detail-report.js?vue&type=script&lang=js&"
import style0 from "./open-so-detail-report.vue?vue&type=style&index=0&id=f5507dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5507dc0",
  null
  
)

export default component.exports